import { Collapse, Table } from 'antd';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

import { AdvancedInfoContainer } from './AdvancedInfo.styles';
import { getKeyCount, getValue, useDataSource, useDeviceAdditionalDetails } from './AdvancedInfo.utils';

const AdvancedInfo = observer(({ entity }: { entity: Entity }) => {
  const { t } = useTranslation();
  const sectionsMap = useDeviceAdditionalDetails(entity);

  return (
    <AdvancedInfoContainer>
      {Object.entries(sectionsMap).map(([section, value]) => {
        const isMetricsSection = section === 'metrics';
        return (
          <Collapse
            key={section}
            defaultActiveKey={getKeyCount(value) > 0 ? ['metrics'] : []}
            expandIconPosition="end"
            items={[
              {
                key: section,
                label: (
                  <span>
                    {t(section)}&nbsp; ({getKeyCount(value)})
                  </span>
                ),
                children: (
                  <Table
                    dataSource={useDataSource(value, isMetricsSection)}
                    pagination={false}
                    showHeader={false}
                    columns={[
                      {
                        key: 'key',
                        width: '50%',
                        render: ({ key }: { key: string }) => key,
                      },
                      {
                        key: 'value',
                        width: isMetricsSection ? '30%' : '50%',
                        render: ({ value }: { value: string }) => <span className="value">{getValue(value)}</span>,
                      },
                      ...(isMetricsSection
                        ? [
                            {
                              key: 'unit',
                              width: '20%',
                              render: ({ unit }: { unit: string }) => <span className="value">{getValue(unit)}</span>,
                            },
                          ]
                        : []),
                    ]}
                  />
                ),
              },
            ]}
          />
        );
      })}
    </AdvancedInfoContainer>
  );
});

export default AdvancedInfo;
